import ReactDOM from "react-dom/client";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import client from "./api/apollo";
import { FluentProvider } from "@fluentui/react-components";
import "./index.css";
import { mildTheme, parentHome } from "./styles/customStyles";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <ApolloProvider client={client}>
    <FluentProvider theme={mildTheme} style={parentHome}>
      <App/>
    </FluentProvider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
